import React from "react";
import { Link } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-semibold text-zinc-900 dark:text-zinc-100 mb-6">
        Admin Dashboard
      </h1>
      <nav className="space-y-2">
        <Link
          to="/admin/collections"
          className="block text-cyan-600 dark:text-cyan-400 hover:underline"
        >
          Manage collections →
        </Link>
      </nav>
    </div>
  );
};

export default AdminDashboard;
